module.exports = __webpack_public_path__ + "static/media/version_overview_icon.0ea9265c.svg";